import { createContext } from "react";

export type TwoFactorMethod = "totp" | "sms";

export type TwoFactorSubmitResult =
  | { error: { code: string; message?: string } }
  | { switchToSms: { maskedPhoneNumber?: string } }
  | null;

export interface TwoFactorModalConfig {
  preferredMethod: TwoFactorMethod;
  maskedPhoneNumber?: string;
  hasSmsFallback?: boolean;
  isSmsVerificationNext?: boolean;
  onSubmit: (
    code: string,
    method: TwoFactorMethod,
    options?: { askForBypassMfa?: boolean }
  ) => Promise<TwoFactorSubmitResult>;
  onRequestSmsFallback?: () => Promise<{ maskedPhoneNumber?: string } | { error: string } | null>;
  onCancel: () => void;
}

export interface TwoFactorContextProps {
  isOpen: boolean;
  config: TwoFactorModalConfig | null;
  openTwoFactorModal: (config: TwoFactorModalConfig) => void;
  closeTwoFactorModal: () => void;
}

export const TwoFactorContext = createContext<TwoFactorContextProps>({
  isOpen: false,
  config: null,
  openTwoFactorModal: () => {},
  closeTwoFactorModal: () => {},
});
